module.exports = __webpack_public_path__ + "static/media/logo.0d5f11dd.png";